/* global angular */

require('./steps-header.component.css')

angular.module('uniformCmp')
  .component('stepsHeader', {
    template: require('./steps-header.component.tpl.html'),
    controller: StepsHeaderCtrl,
    controllerAs: 'vm',
    bindings: {
      formFields: '<',
      currentStep: '<'
    }
  })

StepsHeaderCtrl.$inject = []

function StepsHeaderCtrl () {
  var vm = this

  vm.$onInit = function () {
    vm.steps = vm.formFields.filter(groupOnly)
  }

  function groupOnly (field) {
    return field.fieldType === 'Group'
  }
}
